import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const documentsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDocuments: builder.query<
      CommonResponseType & { data: any },
      { page?: number; limit?: number; search?: string; documentsStatus?: number }
    >({
      query: ({ page = 1, limit = 10, search, documentsStatus }) => {
        const params = new URLSearchParams();
        params.append("page", String(page));
        params.append("limit", String(limit));
        if (search) params.append("search", search);
        if (documentsStatus) {
          params.append("documentsStatus", String(documentsStatus));
        }

        return {
          url: `${END_POINTS.getDocuments}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    verifyDocuments: builder.mutation<
      CommonResponseType & { data: any },
      {
        id: string;
        body: { documentsStatus: 2 | 3; documentRejectReason?: string };
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.verifyDocuments}/${id}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const { useLazyGetDocumentsQuery, useVerifyDocumentsMutation } =
  documentsApi;
